export interface DropdownMenuItem {
  text: string;
  clickHandler?: (menu: DropdownMenuItem, checked?: boolean) => void;
  enabled?: boolean | ((menu: DropdownMenuItem) => boolean);
  children?: DropdownMenuItem[];
  icon?: string;
  subMenuPosition?: DropdownSubMenuPosition;
  checked?: boolean;
  group?: string;
  type: MenuType;
  changeHandler?: (checked: boolean, menu: DropdownMenuItem) => void;
  separator?: DropdownMenuSeperatorPosition;
}

export type DropdownSubMenuPosition = "left" | "right";

export enum MenuType {
  DefaultMenu,
  CheckboxMenu,
  RadiobuttonMenu
}

export type DropdownMenuSeperatorPosition = "top" | "bottom";
